import { KeyOutlined, Person2Outlined, Schedule, VpnKeyOutlined } from '@mui/icons-material'
import { useMediaQuery } from '@mui/material'
import React, { useContext, useState, useEffect } from 'react'
import { BufferService, LoadingContext, MTabsInpage, NavigateContext, M_StateActions} from 'src/M_Components'
import ChangePassword from './ChangePassword'
import { useTranslation } from 'react-i18next'
import UserConfig from 'src/pages/Users/userConfig'
import RoleConfig from 'src/pages/Roles/roleConfig'
import './settings.css'
import { useDispatch, useSelector } from 'react-redux'
import LogPage from 'src/pages/Logs/LogPage'
import ApiKeyConfig from 'src/pages/ApiKeys/ApiKeyConfig'

//unified tabs styling
import 'src/pages/tabsInpage.css'

export default function SettingsPage({ bufferService, roles, checkPermissions  }) {
  const dispatch = useDispatch()
  const M_State = useSelector((state) => state.StateKeyValue)
  const ctx = useContext(LoadingContext)
  const ctx2 = useContext(NavigateContext)
  const matches = useMediaQuery('(min-width:900px)')
  const [id, setId] = useState(M_State.filter(obj => obj.key === 'selectedTab')[0]?.value)
  const [menu, setMenu] = useState(1)
  const [user, setUser] = useState(null)
  const { t } = useTranslation()
  const UserService = bufferService || new BufferService('identity/userrole');
  const {renameTab} = useContext(NavigateContext)
  const selectedTab = useSelector(s => s.StateKeyValue.find(o => o.key === 'selectedTab')?.value);

  const sessionKeys = ['menu', 'user']

  function getSessionKeys() {
    return [
      menu, user
    ]
  }

  useEffect(() => {
    if (!selectedTab || !renameTab) return;
    renameTab(id, t('SettingsSpan'))
  }, [t, selectedTab])

  useEffect(() => {
    getSessionStorageData(id)
    // eslint-disable-next-line
  }, [])

  const getSessionStorageData = (sessionID) => {
    ctx.setIsLoad(true)
    const M_StateData = M_State.filter(obj => obj.key === sessionID)[0]?.value
    if (M_StateData) {
      const tempM = M_StateData?.filter(obj => obj?.key === `menu`)[0]?.value
      const tempU = M_StateData?.filter(obj => obj?.key === `user`)[0]?.value
      if (tempM || tempU) {
        setMenu((tempM))
        setUser((tempU))
        ctx.setIsLoad(false)
        return
      }
    }
    ctx.setIsLoad(false)
    // get()
  }

  const sessionStorageMachine = (id, key, value) => {
    let tempObj = {}
    // eslint-disable-next-line
    if (eval(value) instanceof Map) {
      // eslint-disable-next-line
      tempObj = { key: `${key}`, value: (Array.from(eval(value))) }
    } else {
      // eslint-disable-next-line
      tempObj = { key: `${key}`, value: (eval(value)) }
    }
    return tempObj
  }

  // eslint-disable-next-line
  useEffect(() => {
    const newId = M_State.filter(obj => obj.key === 'selectedTab')[0]?.value
    if (newId !== id) {
      setId(newId)
      getSessionStorageData(newId)
    }
  })

  useEffect(() => {
    const tempArray = []
    sessionKeys.forEach(key => {
      tempArray.push(sessionStorageMachine(id, key, key))
    })
    dispatch(M_StateActions.addM_State({ key: id, value: tempArray }))
    // eslint-disable-next-line
  }, [id, menu, user])

  // const get = () => {
  //   ctx.setIsLoad(true)
  //   UserService.get().then(res => {
  //     ctx.setIsLoad(false)
  //     if (res.name === 'AxiosError') {
  //       ctx.toastMessages('error', res.response.data.Errors, '')
  //       return
  //     }
  //     setUser(res)
  //   })
  // }

  //Function to handle what tabs are allowed based on permissions
  const allowedTabs = () => {
    const tabArray = []
    tabArray.push({ iconTab: <KeyOutlined style={{ fontSize: '1.5rem' }} data-testid="tab-key" />, labelTab: t('ChangePassword'), id: 1 })
    if (checkPermissions('Users')) {
      tabArray.push({ iconTab: <Person2Outlined style={{ fontSize: '1.5rem' }} data-testid="tab-person" />, labelTab: t('Users'), id: 2 })
    }
    if (checkPermissions('Profiles')) {
      tabArray.push({ iconTab: <i className="pi pi-wrench" style={{ fontSize: '1.5rem' }} data-testid="tab-role" ></i>, labelTab: t('Roles'), id: 3 })
    }
     if (checkPermissions('Accounts')) {
      tabArray.push({ iconTab: <VpnKeyOutlined style={{ fontSize: '1.5rem' }} data-testid="tab-apikeys" />, labelTab: t('ApiKeys'), id: 4 })
    }
    if (checkPermissions('Users')) {
      tabArray.push({ iconTab: <Schedule style={{ fontSize: '1.5rem' }} data-testid="tab-schedule" />, labelTab: t('UserLogs'), id: 5 })
    }
   
    return tabArray
  }

  return (
    // Backward-compat bridge + unified layout classes (visual only)
    <div className='tabsInpage divGlobalSettings' data-testid="settings-page">
      <div className='tabsInpage__title titleSettings' style={{ color: ctx.secondaryColor }} data-testid="settings-title">
        {t("SettingsSpan")}
      </div>
      {/* Standard body split: sidebar (tabs) + content (panel) */}
      <div className="tabsInpage__body" data-testid="settings-container">
        {/* Sidebar column (controlled by CSS: widths, separator, responsive) */}
        <div className="tabsInpage__sidebar" data-testid="settings-tabs">
          <MTabsInpage
            type={matches ? 'column' : 'tabs'}
            renderTabs={allowedTabs()}
            firstTabOpen={menu}
            onGetTab={(obj, obj2) => {
              if (matches) {
                setMenu(obj.id)
              } else {
                setMenu(obj2.id)
              }
            }}
            fixedArea={false}
          />
        </div>
        {/* Right content panel. Legacy class kept for bridge; no behavior changes */}
        <div className='tabsInpage__content settingsPageMainDiv'>
          {menu == '1' && (
            <ChangePassword
              Email={user?.User?.Email}
              data-testid="user-email" 
            />
          )}
          {menu == '2' && <UserConfig roles={roles?.map(vl => vl.Value)} onCreateTab={ctx2.newTab} toastMessages={ctx.toastMessages} />}
          {menu == '3' && <RoleConfig roles={roles?.map(vl => vl.Value)} onCreateTab={ctx2.newTab} toastMessages={ctx.toastMessages} />}
          {menu == '4' && <ApiKeyConfig roles={roles?.map(vl => vl.Value)} onCreateTab={ctx2.newTab} toastMessages={ctx.toastMessages}/>}
          {menu == '5' && <LogPage roles={roles?.map(vl => vl.Value)} toastMessages={ctx.toastMessages} />}
        </div>
      </div>
    </div>
  );

}
